/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".a-i-c[_ngcontent-%COMP%]{-ms-flex-align:end;align-items:flex-end}@media only screen and (max-width:768px){.expiration[_ngcontent-%COMP%]{padding-top:4px}}"];
export { styles as styles };
